<template>
  <div class="index" v-cloak>
    <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner.length > 0">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <img :src="item.pic" />
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>
    <div class="nav acea-row">
      <router-link
        :to="item.wap_url ? item.wap_url + '?shopid=' + shopid : ''"
        class="item"
        v-for="(item, index) in menus"
        :key="index"
      >
        <div class="pictrue"><img v-lazy="item.pic" alt="img" /></div>
        <div>{{ item.name }}</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { index } from "@api/roots";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import { getQueryValue } from "@utils/utils";
let vm = null;
export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide
  },
  props: {},
  data: function() {
    return {
      shopid: "",
      banner: [],
      menus: [],
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function() {
            const realIndex = this.realIndex;
            vm.goUrl(realIndex);
          }
        }
      }
    };
  },
  created() {
    vm = this;
  },
  mounted: function() {
    var shopid = getQueryValue("shopid");
    shopid = shopid.replace("#/", "");
    localStorage.setItem("shopid", shopid);
    this.shopid = shopid;
    this.getIndex();
  },
  methods: {
    getIndex() {
      index().then(res => {
        this.banner = res.data.banner;
        this.menus = res.data.menus;
      });
    }
  }
};
</script>
<style scoped>
.index .header {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #00a64c;
  text-align: center;
  color: #ffffff;
  font-weight: bold;
  font-size: 18px;
}
</style>
